export default __webpack_public_path__ + "static/media/MSPartner.2f6444dd.svg";